import {
  PATIENT_NOTE_ADD_ERROR,
  PATIENT_NOTE_ADD_REQUEST,
  PATIENT_NOTE_ADDED,
  PATIENT_NOTE_DELETED,
  PATIENT_NOTE_UPDATED,
  PATIENT_NOTES_ERROR,
  PATIENT_NOTES_RECEIVED,
  PATIENT_NOTES_REQUEST,
  PATIENT_NOTES_UNLOAD,
} from '../constants';

/**
 * MED-922 - the notes on one patient.
 *
 * The list is tagged with the patient it was fetched for. The invoice screen reads this store to
 * decide whether to pop a modal, and without the tag a list left over from the previous patient
 * would fire on the next invoice - a note about the wrong family, in a modal, on the screen where
 * somebody is about to pick up the phone. Consumers check `patientNotesForPatientId` before
 * trusting `patientNotes`.
 *
 * Adds, updates and deletes are applied in place rather than by refetch. That matters most for
 * clearing isPopup: it is the only way a popup stops, and a stale flag in the store would fire
 * the modal again on the next render.
 */
const initialState = {
  patientNotes: [],
  patientNotesForPatientId: null,
  isFetchingPatientNotes: false,
  isAddingPatientNote: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PATIENT_NOTES_REQUEST:
      return { ...state, isFetchingPatientNotes: true };

    case PATIENT_NOTES_RECEIVED:
      return {
        ...state,
        patientNotes: action.data['hydra:member'],
        patientNotesForPatientId: action.patientId,
        isFetchingPatientNotes: false,
      };

    case PATIENT_NOTES_ERROR:
      return {
        ...state,
        patientNotes: [],
        patientNotesForPatientId: null,
        isFetchingPatientNotes: false,
      };

    case PATIENT_NOTES_UNLOAD:
      return { ...initialState };

    case PATIENT_NOTE_ADD_REQUEST:
      return { ...state, isAddingPatientNote: true };

    case PATIENT_NOTE_ADDED:
      return {
        ...state,
        patientNotes: [action.data, ...state.patientNotes],
        isAddingPatientNote: false,
      };

    case PATIENT_NOTE_ADD_ERROR:
      return { ...state, isAddingPatientNote: false };

    case PATIENT_NOTE_UPDATED:
      return {
        ...state,
        patientNotes: state.patientNotes.map((note) => (note.id === action.data.id ? action.data : note)),
      };

    case PATIENT_NOTE_DELETED:
      return {
        ...state,
        patientNotes: state.patientNotes.filter((note) => note.id !== action.id),
      };

    default:
      return state;
  }
};

export default reducer;
